var map = {
	"./icon-account.svg": "66a2",
	"./icon-add.svg": "eb95",
	"./icon-alert.svg": "96e3",
	"./icon-apple.svg": "17bc",
	"./icon-arrow.svg": "f9d6",
	"./icon-asmr.svg": "a1cb",
	"./icon-bad-language.svg": "6a6a",
	"./icon-beep-sound.svg": "8c1d",
	"./icon-bits.svg": "12d2",
	"./icon-burger.svg": "debb",
	"./icon-category.svg": "cbbb",
	"./icon-check-circle.svg": "0282",
	"./icon-check-v2.svg": "538f",
	"./icon-check.svg": "0782",
	"./icon-circle-info.svg": "21e3",
	"./icon-circle-status.svg": "1af8",
	"./icon-close.svg": "8989",
	"./icon-config.svg": "4859",
	"./icon-connected.svg": "c28a",
	"./icon-copy.svg": "34a2",
	"./icon-creators.svg": "2a2b",
	"./icon-csgo.svg": "6a3a",
	"./icon-discord-small.svg": "d12f",
	"./icon-discord.svg": "a4f7",
	"./icon-edit.svg": "5022",
	"./icon-external-link.svg": "4941",
	"./icon-externalLink.svg": "b66c",
	"./icon-facebook-small.svg": "3f32",
	"./icon-facebook.svg": "0ec4",
	"./icon-footer-volume.svg": "2fa5",
	"./icon-fortnite.svg": "35f5",
	"./icon-google.svg": "59eb",
	"./icon-gta.svg": "420a",
	"./icon-headphones-empty.svg": "6ddc",
	"./icon-headphones-error.svg": "add9",
	"./icon-headphones-off.svg": "cb5f",
	"./icon-headphones-on.svg": "a76b",
	"./icon-help.svg": "413b",
	"./icon-hide.svg": "890f",
	"./icon-import.svg": "03cf",
	"./icon-info.svg": "ce0a",
	"./icon-input.svg": "b1e4",
	"./icon-key.svg": "bf24",
	"./icon-list.svg": "5fc6",
	"./icon-lock-closed.svg": "3c7e",
	"./icon-lock.svg": "f2c1",
	"./icon-logo-voicemod.svg": "b744",
	"./icon-master-volume-off.svg": "428b",
	"./icon-master-volume-on.svg": "53dc",
	"./icon-mic-empty.svg": "b7f9",
	"./icon-mic-error.svg": "04d2",
	"./icon-mic-off.svg": "67c2",
	"./icon-mic-on.svg": "261e",
	"./icon-microphone-off.svg": "f1cd",
	"./icon-microphone-on.svg": "aa30",
	"./icon-mode-compact.svg": "733c",
	"./icon-mode-extended.svg": "f706",
	"./icon-obs.svg": "c07e",
	"./icon-order.svg": "c827",
	"./icon-output.svg": "5651",
	"./icon-overwatch.svg": "e2b0",
	"./icon-pause.svg": "9dcf",
	"./icon-play-pause.svg": "84c5",
	"./icon-play-stop.svg": "d260",
	"./icon-play.svg": "411f",
	"./icon-plugins.svg": "2bfd",
	"./icon-pubg.svg": "a77f",
	"./icon-queue-check.svg": "557f",
	"./icon-random-off.svg": "99a6",
	"./icon-random-on.svg": "d990",
	"./icon-reddit-small.svg": "ceb3",
	"./icon-reddit.svg": "a0af",
	"./icon-refresh.svg": "56f4",
	"./icon-reset.svg": "5944",
	"./icon-search.svg": "9e08",
	"./icon-secondlife.svg": "687a",
	"./icon-settings.svg": "3598",
	"./icon-share.svg": "5742",
	"./icon-skype.svg": "e21c",
	"./icon-soundboard.svg": "d056",
	"./icon-steam.svg": "30d1",
	"./icon-stop.svg": "3e23",
	"./icon-streamdeck.svg": "b2ef",
	"./icon-streamlabs.svg": "4bee",
	"./icon-sword.svg": "c396",
	"./icon-teamspeak.svg": "6159",
	"./icon-tiktok.svg": "d607",
	"./icon-timer.svg": "8e65",
	"./icon-trash.svg": "3215",
	"./icon-twitch-prime.svg": "24b4",
	"./icon-twitch.svg": "9a60",
	"./icon-twitter-small.svg": "7400",
	"./icon-twitter.svg": "ac1d",
	"./icon-update.svg": "be67",
	"./icon-upload.svg": "eaa7",
	"./icon-valorant.svg": "874c",
	"./icon-video-pause.svg": "224ee",
	"./icon-video-play-hover.svg": "3a44",
	"./icon-video-play.svg": "907f",
	"./icon-view.svg": "8cf7",
	"./icon-voicelab.svg": "3610",
	"./icon-voices.svg": "343b",
	"./icon-vrchat.svg": "5848",
	"./icon-warning.svg": "b8bb",
	"./icon-xsplit.svg": "0e72",
	"./icon-youtube.svg": "b2ff",
	"./icon-zoom.svg": "fc23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f21e";